// postprocessAiResult.ts

import { normalizePsyId, resolvePsyMeta } from './parsePsyInfo';

type SummaryItem = {
    psyItemId: string;
    target?: string;
    englishTitle?: string;
    koreanTitle?: string;
    description: string;
};

type AiResult = {
    totalResult: any;
    summaryList: SummaryItem[];
    recommendList: { keyword: string; description: string }[];
};

export function extractUniqueIds(testRawData: string): string[] {
    const re = /PSY_ITEM_ID["\s]*:[\s]*["']([^"']+)["']/gi;
    const ids: string[] = [];
    let m: RegExpExecArray | null;
    while ((m = re.exec(testRawData)) !== null) ids.push(m[1]);
    // 고유 + 정규화 키 기준으로 유일화
    const seen = new Set<string>();
    const ordered: string[] = [];
    for (const id of ids) {
        const key = normalizePsyId(id);
        if (!seen.has(key)) {
            seen.add(key);
            ordered.push(id);
        }
    }
    return ordered;
}

export function applyPsyMeta(result: AiResult, testRawData: string): AiResult {
    const uniqueIds = extractUniqueIds(testRawData);

    // 1) 요약 리스트를 psyItemId 기준으로 재구성/필터링
    const byKey = new Map<string, SummaryItem>();
    for (const item of result.summaryList || []) {
        if (!item?.psyItemId) continue;
        const key = normalizePsyId(item.psyItemId);
        if (!byKey.has(key)) byKey.set(key, { ...item, psyItemId: item.psyItemId });
    }

    const normalizedList: SummaryItem[] = uniqueIds.map((rawId) => {
        const key = normalizePsyId(rawId);
        const base = byKey.get(key) ?? { psyItemId: rawId, description: '' };
        const meta = resolvePsyMeta(rawId);

        return {
            ...base,
            target: meta?.target ?? base.target, // 기본값 제거
            englishTitle: meta?.englishTitle ?? base.englishTitle,
            koreanTitle: meta?.koreanTitle ?? base.koreanTitle,
        };
    });

    // 2) 허용 값만 남기기
    const ALLOWED_TARGETS = new Set(['자녀용', '부모용', '부모보고용']);
    for (const s of normalizedList) {
        if (!ALLOWED_TARGETS.has(s.target || '')) s.target = '자녀용';
    }

    // 3) 최종 개수 일치 보장
    return {
        ...result,
        summaryList: normalizedList,
    };
}
